import React from 'react';
import '../profile.css';
import axios from 'axios';
import { PayPalButton } from "react-paypal-button-v2";
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
const queryString = require('query-string');


function getTutor(tutorEmail){
    var myParam = {
        email: tutorEmail
    }
  
    axios.post("https://auxilliabackend.herokuapp.com/getTutorProfile",myParam)
    .then(function (response) {
      
      const data = response.data;
      console.log(data);

      var classes = "";
      for (var i = 0;i <  data.Classes.length;i++)
      {
        if(i!=data.Classes.length-1)
          classes = classes + data.Classes[i] + ", \n";
        else
          classes = classes + data.Classes[i] + "\n";
      }

      var times = [];
      for (var i = 0;i <  data.AvailableTimes.length;i++)
      {
        times.push(data.AvailableTimes[i]);
      }




      window.tutorProf.addTutorToState(data.ClassYear,classes,data.Paypal,data.Name,data.Price,times);  
      return data;
  
  
      //window.location.reload(true);
    })
    .catch(function (error) {
      console.log(error);
    });
  }


  function postTutorDb(name, paypal, price, classes, classYear)
  {
      //const user = useContext(UserContext);//take email out of parameters
      //const {email} = user;
      console.log("POSTING");
      var myParams = {
        name: name,
        email: localStorage.getItem('email'),
        paypal: paypal,
        price: price,
        classes: classes,
        classYear: classYear
    }
      console.log(myParams);
    axios.post("https://auxilliabackend.herokuapp.com/updateTutor",myParams)
    .then(function (response) {
      //window.location.reload(true);
      localStorage.setItem('classes', response.classList);
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  function postNewTime(time)
  {
    console.log("POSTING");
    var myParams = {
      time: time,
      email: localStorage.getItem('email')
    }
    console.log(myParams);
    axios.post("https://auxilliabackend.herokuapp.com/updateTimes",myParams)
    .then(function (response) {
        window.location.reload(true);
        //localStorage.setItem('classes', response.classList);
    })
    .catch(function (error) {
        console.log(error);
    });
  }
    

  function sleep(ms) {
    return new Promise(
      resolve => setTimeout(resolve, ms)
    );
  }

  function getZoom(topic,comments)
    {
        var myParam = {topic:topic,comments:comments};

        axios.post("https://auxilliabackend.herokuapp.com/getMeetingNow",myParam)
        .then(function (response) {

        const data = response.data;
        console.log("response:")
        console.log(data);


        //window.location.reload(true);
        })
        .catch(function (error) {
        console.log("SOMETHING WENT WRONG");
        console.log(error);
        });
    }

//   function transSucces()
//   {
//     const history = useHistory();
//     history.push({pathname: '/reserve'});
//   }

//Functional Component 
class tutorProfileEditPage extends React.Component{
    constructor(props)
    {
        super(props);
        window.tutorProf = this;
        this.state = {
        classYear: "",
        classes: "",
        email:"",
        name:"",
        price:"",
        times:[],
        class:"",
        newTime:""

        }
        this.submitter = this.submitter.bind(this);
        this.submitter2 = this.submitter2.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount()
    {
        const mail = localStorage.getItem('email');
        console.log("this is the email:",mail);
        //const mail = queryString.parse(window.location.search).email;
        getTutor(mail);
    }

    addTutorToState(classYear,classes,email,name,price,times)
    {
        this.setState({
            classYear: classYear,
            classes: classes,
            email:email,
            name:name,
            price:price,
            times:times
        });
        
    }

    handleInputChange = (event) => {
        console.log("Changing", event.target.name);
        this.setState({
          [event.target.name]: event.target.value
        })
      }

    reroute(){
        getZoom("CSCEC",this.state.comments);
        this.props.history.push({pathname: '/reserve'});
    }

    submitter(e){
        console.log("submitting function");
        e.preventDefault();
        postTutorDb(this.state.name, this.state.email, this.state.price, this.state.classes, this.state.classYear);
        // postTutorDb(this.state.name,this.state.email,this.state.paypal, this.state.price, this.state.classes, this.state.classYear);
        console.log("Submit log in information");
        window.location.reload(true);
      }
    async submitter2(e){
        console.log("submitting function");
        e.preventDefault();
        await postNewTime(this.state.newTime);
        // postTutorDb(this.state.name,this.state.email,this.state.paypal, this.state.price, this.state.classes, this.state.classYear);
        console.log("Submit log in tghsghdhhdation");
        //this.props.history.push({pathname: '/chats'});
    }
    
    render()
    {
        return (
            <div className="App">
                <body className = "profile-body">


                <div class = "tutorT">
                    <div>
                        <h1>Tutor Profile Information</h1>
                        <form id="editTForm" style={{position:"relative"}} onSubmit = {this.submitter}>
                                {/* <p>Username</p> */}
                                <p>Name</p>
                                <input type = "text" name = "name" placeholder = "Name" onChange = {this.handleInputChange} value={this.state.name}></input>
                                {/* <p>Email: (youremail@emailaddress.com)</p>
                                <input type = "text" name="email" placeholder = "Enter Email" onChange = {this.handleInputChange}></input> */}
                                <p>Paypal</p>
                                <input type = "text" name = "paypal" placeholder = "Paypal Email" value={this.state.email} onChange = {this.handleInputChange}></input>
                                <p>Price (Only put the number, no dollar sign)</p>
                                <input type="text" name="price" placeholder = "Tutor Price" onChange={this.handleInputChange} value={this.state.price}></input>
                                <p>Classes (Comma Separated w/ One Space: CSCE 315, MATH 151)</p>
                                <input type="text" name="classes" placeholder = "Classes Tutored" onChange={this.handleInputChange} value={this.state.classes}></input>
                                <p>Class Year</p>
                                <input type="text" name="classYear" placeholder = "Class Year" onChange={this.handleInputChange} value={this.state.classYear}></input>
                                <p>Submit</p>
                                <input type = "submit" name = "submit" value = "Change Information" onChange = {this.handleInputChange}></input >
                        </form>
                    </div>
                  
                
                    <div class = "timesSchedule">   {/* should be an inline block */}
                        {/* <div class = "rButtons">  

                        </div> */}
                        <div class = "tutorTime">
                            <h1>Add times here:</h1>
                            <form class = "inline" onSubmit={this.submitter2}>
                                <div>
                                    <p>Times Available:</p>
                                    
                                    <select id="cars" name="cars">
                                        {this.state.times.map((item,i) => {return(<option selected={this.state.times[i]} key={this.state.times[i]} value={this.state.times[i]}>{this.state.times[i]}</option>)})}
                                    </select>
                                    {/* <input type="submit"></input> */}
                                </div>

                                <div class = "space">
                                </div>

                                <div class = "comments">
                                    <p>Enter Time Here:</p>
                                    <input type = "datetime-local" name = "newTime" onChange={this.handleInputChange} placeholder = "Put anything you would like the tutor to know here" ></input>
                                    <input type = "submit" name = "submit" value = "Change Information" onChange = {this.handleInputChange}></input >
                                    {/* <input type = "submit" name = "" value = "Submit" ></input > */}
                                </div>
                            </form>
                        </div>
                        
                    </div>

        
                </div>
                </body>
            </div>
        );
    }
  }



export default tutorProfileEditPage;